module.exports = __webpack_public_path__ + "static/media/arrow.3eb1be84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleSelect/arrow.svg
// module id = 335
// module chunks = 0